import { createContext, useContext, useState } from 'react';

const InquiryContext = createContext(null);

export function InquiryProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState(null);

  const openInquiry = (product) => {
    setProduct(product);
    setIsOpen(true);
  };

  const closeInquiry = () => {
    setIsOpen(false);
    setProduct(null);
  };

  return (
    <InquiryContext.Provider value={{ isOpen, product, openInquiry, closeInquiry }}>
      {children}
    </InquiryContext.Provider>
  );
}

export const useInquiry = () => useContext(InquiryContext);